import { render, staticRenderFns } from "./ContestLegals.vue?vue&type=template&id=0b524325&scoped=true&"
import script from "./ContestLegals.vue?vue&type=script&lang=js&"
export * from "./ContestLegals.vue?vue&type=script&lang=js&"
import style0 from "./ContestLegals.vue?vue&type=style&index=0&id=0b524325&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b524325",
  null
  
)

export default component.exports